var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.668 9.083q.067 0 .13.012l.016.003.021.006a.75.75 0 0 1 .362.199.8.8 0 0 1 .126.176q.02.033.035.067.01.027.018.056c.024.073.041.15.041.231v4a.75.75 0 0 1-1.5 0v-2.188L2.53 15.03a.75.75 0 0 1-1.06-1.061l3.386-3.387h-2.19a.75.75 0 0 1 0-1.5zM13.47 1.97a.75.75 0 0 1 1.06 1.06l-3.385 3.386h2.188a.75.75 0 0 1 0 1.5l-4 .001a.7.7 0 0 1-.231-.04c-.019-.007-.038-.01-.056-.018q-.035-.016-.067-.036a.7.7 0 0 1-.176-.126.75.75 0 0 1-.208-.399 1 1 0 0 1-.012-.132v-4a.75.75 0 0 1 1.5 0v2.19z"
  })));
};
export default Svg16;